/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {StackParams} from '../../../data/types/navigation';
import {AssuranceServices} from '../../../services/applicatif/assurance';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {Loader} from '../../components/Loader';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../components/PageContainer';
import {Form} from './Form';

// TODO: gérerna ilay hoe contrat iza sy iza pour un type d'avenant
// Mila manontany BA
type NavigationProps = StackNavigationProp<StackParams, 'DemanderAvenant'>;

export const FDemanderAvenant = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();

  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [messageError, setShowMessageError] = useState('');
  const {avenantContrat} = props;
  const [listTypeDemande, setListTypeDemande] = useState([]);
  const {getTermeAvenant} = AssuranceServices();

  const {idContrat, typeContrat, agenceAro} = props.route.params;
  const [dataDto, setDataDto] = useState<any>({
    contratId: idContrat,
    termeAvenantId: '',
    message: '',
    agence: agenceAro,
    typeContrat: typeContrat,
  });

  const mapList = (list: any) => {
    list = list.map((elt: any) => {
      return {
        value: elt.id,
        label: elt.libelle,
      };
    });
    const listVide = {value: '', label: ''};
    list.unshift(listVide);
    return list;
  };

  useEffect(() => {
    getListTermeAvenant();
  }, []);

  const getListTermeAvenant = () => {
    setIsLoading(true);
    getTermeAvenant(typeContrat).then(res => {
      setIsLoading(false);
      if (res && res.data && res.data.items) {
        const _data = mapList(res.data.items);
        setListTypeDemande(_data);
      } else {
        setShowError(true);
        res && setShowMessageError(res.message);
      }
    });
  };

  const handleCancel = () => {
    goBack();
  };

  const handleSubmit = (response: any) => {
    const _data = {...response};
    setDataDto(_data);
    setIsLoading(true);
    avenantContrat(response, '').then((res: any) => {
      if (res && !res.isError) {
        setPostSuccess(true);
      } else {
        setShowError(true);
        res && setShowMessageError(res.message);
      }
      setIsLoading(false);
    });
  };

  return (
    <View>
      <HeaderScreen
        title="Demander avenant"
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {/** Confirmation modal */}
        {postSucces && (
          <ConfirmationModal
            title="Demande avenant contrat"
            content="Votre demande a bien été envoyée, nous reviendrons vers vous dans les plus brefs délais"
            btn1="OK"
            handleBtn1={() => {
              setPostSuccess(false);
              navigate('MonEspace');
            }}
          />
        )}
        {showError && (
          <ConfirmationModal
            title="Erreur"
            content={messageError}
            btn1="OK"
            handleBtn1={() => setShowError(false)}
          />
        )}
        {/** Loading */}
        {IsLoading && <Loader />}

        {/** Form content */}
        {!postSucces && !IsLoading && (
          <Form
            data={dataDto}
            listTypeDemande={listTypeDemande}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const DemanderAvenant: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FDemanderAvenant);
